import { Outlet } from 'react-router-dom';

import { Stack } from '@mui/material';

import { ServerNotificationBanner } from '@/entities/user/currentUser';

// eslint-disable-next-line boundaries/element-types
import { DesktopSidebar } from '../../../sidebar';
import { SContainer } from './styled';

export const MainLayout = () => {
  return (
    <SContainer>
      <DesktopSidebar />
      <Stack flex="1">
        <ServerNotificationBanner />
        <Outlet />
      </Stack>
    </SContainer>
  );
};
